const filterSubLinks = () => {
  const input = document.getElementById('searchBar');
  if (!input) return;
  const filter = input.value.toLowerCase();
  const items = document.getElementsByClassName('sub-link-item');

  for (let i = 0; i < items.length; i++) {
    const titleEl = items[i].getElementsByClassName('sub-link-title')[0];
    if (!titleEl) continue;
    const txtValue = titleEl.textContent || titleEl.innerText;
    items[i].style.display = txtValue.toLowerCase().indexOf(filter) > -1 ? '' : 'none';
  }
};

document.addEventListener('DOMContentLoaded', () => {
  document.getElementById('searchBar')?.addEventListener('input', filterSubLinks);
});
